// Generated by scripts/build-ui-icons.mjs.
export { ArrowsClockwise as default } from "../ui/glyphs-1";
